import { isBefore } from 'date-fns';

import { fg } from '@confluence/feature-gating';
// eslint-disable-next-line confluence-targeting-usage/no-legacy-tap-personalization-api -- To be migrated to useSiteTraits. See ACTIVATION-2527
import { useSitePersonalizationQuery } from '@confluence/onboarding-helpers/entry-points/hooks/useSitePersonalizationQuery.ts';
import { useIsLicensed } from '@confluence/session-data/entry-points/useAccessStatus.ts';
import { useSessionData } from '@confluence/session-data/entry-points/useSessionData.ts';
import { useExperimentalSiteUserPersonalization } from '@confluence/targeting/entry-points/useExperimentalSiteUserPersonalization.ts';

const CONFLUENCE_FIRST_ACTIVE_TRAIT = 'confluence_first_active';

export const useIsAIFCOnbardingEligible = () => {
	const { isRovoLLMEnabled, cloudId, userId } = useSessionData();
	const isLicensed = useIsLicensed();

	const {
		data: siteUserPersonalizationData,
		loading: siteUserPersonalizationLoading,
		error: siteUserPersonalizationError,
	} = useExperimentalSiteUserPersonalization({
		variables: {
			cloudId,
			userId: userId!,
		},
		skip:
			!userId ||
			!cloudId ||
			!isLicensed ||
			!isRovoLLMEnabled ||
			!fg('aifc_onboarding_killswitch') ||
			!fg('aifc_create_enabled'),
	});

	const siteUserPersonalizationAttributes =
		siteUserPersonalizationData?.experimentalSiteUserPersonalization?.attributes;

	const confluenceFirstActive = siteUserPersonalizationAttributes?.find(
		({ name }: { name: string }) => name === CONFLUENCE_FIRST_ACTIVE_TRAIT,
	)?.value;

	const {
		attributes: sitePersonalizationAttributes,
		loading: sitePersonalizationLoading,
		error: sitePersonalizationError,
	} = useSitePersonalizationQuery({
		cloudId,
		skip:
			!cloudId ||
			!isLicensed ||
			!isRovoLLMEnabled ||
			!fg('aifc_onboarding_killswitch') ||
			!fg('aifc_create_enabled'),
	});

	const AIFCBetaEnrolledDateTime = sitePersonalizationAttributes?.find(
		({ name }: { name: string }) => name === 'confluence_aifc_enabled_datetime',
	)?.value;

	const isExistingUserBeforeAIFCBetaEnrolled =
		!!confluenceFirstActive &&
		!!AIFCBetaEnrolledDateTime &&
		isBefore(new Date(confluenceFirstActive), new Date(AIFCBetaEnrolledDateTime));

	if (
		sitePersonalizationError ||
		sitePersonalizationLoading ||
		siteUserPersonalizationError ||
		siteUserPersonalizationLoading ||
		!fg('aifc_onboarding_killswitch') ||
		!fg('aifc_create_enabled')
	) {
		return {
			isAIFCOnbardingEligible: false,
			error: sitePersonalizationError || siteUserPersonalizationError,
			loading: sitePersonalizationLoading || siteUserPersonalizationLoading,
		};
	}

	return {
		isAIFCOnbardingEligible: isExistingUserBeforeAIFCBetaEnrolled,
		loading: false,
	};
};
